module.exports = __webpack_public_path__ + "img/icon-ai-gray.fae63e8e.svg";